export const getSecondAnalysesData = state => state.secondAnalyses.all;
export const getSecondAnalysisData = state => state.secondAnalyses.secondAnalysis;
export const secondAnalysesIsFetching = state => state.secondAnalyses.loading.all;
export const secondAnalysisIsFetching = state => state.secondAnalyses.loading.secondAnalysis;